import { cva, type VariantProps } from "class-variance-authority";
import { cx } from "class-variance-authority";
import React from "react";
import type { ReactNode } from "react";

import { Skeleton } from "../Skeleton/Skeleton";

import * as styles from "./Badge.module.scss";

const badgeVariant = cva(styles.badge, {
  variants: {
    color: {
      gray: styles.gray,
      success: styles.success,
      warning: styles.warning,
      danger: styles.danger,
      info: styles.info,
    },
  },
  defaultVariants: {
    color: "gray",
  },
});

export type BadgeProps = React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof badgeVariant> & {
    children: ReactNode;
    loading?: boolean;
  };

export default ({ children, color, loading, className }: BadgeProps) => {
  const Component = loading ? Skeleton : "div";

  return (
    <Component
      className={cx(
        badgeVariant({ color }),
        { [styles.loading]: loading },
        className,
      )}
      mode={"light"}
    >
      {children}
    </Component>
  );
};
